import { createAction } from '@'
import { SetFormValues } from '@form'
import { SetModalVisible } from '@modal'

export default createAction('OpenHotelRegionForm', async hotelId => {
    SetFormValues('HotelCoverageRegionForm', {
        hotel_id: hotelId,
        region_ids: '',
        supplier_code: 'EPS'
    })
    SetModalVisible('HotelCoverageRegionForm', true)
})
